module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "title-chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781466815902_toc01#toctitle3",
      "id": "title3"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MUFFINS AND SCONES")])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('div', {
    staticClass: "title-section1"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781466815902_toc01#toctitle4",
      "id": "title4"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Blueberry Muffins")])])])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("These muffins are so buttery and moist that they make a perfect muffin base. You can add whatever fruit you desire to them.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Preheat the oven to 400 degrees. Grease twelve 3 × 1 "), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v("-inch muffin cups.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("In a large bowl, stir together the flour, baking powder, baking soda, sugar, and salt.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("In a medium bowl, combine the melted butter, milk, and eggs. Whisk the mixture until it is combined.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Combine the butter mixture with the dry ingredients and mix it lightly until just moistened. Fold in the blueberries. Spoon the mixture evenly into the prepared muffin cups.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Bake them for 25 to 30 minutes or until a cake tester or a toothpick comes out clean when inserted in the center of one muffin.")])]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "blocktext"
  }, [_c('div', {
    staticClass: "p-br-blocktext"
  }, [_c('span', [_vm._v("3 cups all-purpose flour "), _c('br'), _vm._v("4 "), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v(" teaspoons baking powder "), _c('br'), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v(" teaspoon baking soda "), _c('br'), _vm._v("1¼ cups granulated sugar "), _c('br'), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v(" teaspoon salt "), _c('br'), _vm._v("1 cup salted butter, melted "), _c('br'), _vm._v("1¼ cups milk "), _c('br'), _vm._v("2 large eggs, lightly beaten "), _c('br'), _vm._v("2 cups fresh or frozen blueberries")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc-blocktext"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Yield: 12 muffins")])])])]), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('div', {
    staticClass: "title-section1"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781466815902_toc01#toctitle5",
      "id": "title5"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Carrot Muffins")])])])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("When testing this Tate’s Bake Shop recipe for home use, I worked late at night and thought I would wait and taste them in the morning. My husband left early for work and took the whole batch with him. When I asked if there were any left for me to try, he said, “No, everyone ate three”! In my world, that means this one is a winner. Carrot muffins have the taste of carrot cake, but they are not as sweet and rich.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "blocktext"
  }, [_c('div', {
    staticClass: "p-br-blocktext"
  }, [_c('span', [_vm._v("2 cups all-purpose flour "), _c('br'), _vm._v("2 teaspoons baking soda "), _c('br'), _vm._v("2 teaspoons cinnamon "), _c('br'), _vm._v("¼ teaspoon salt "), _c('br'), _vm._v("¾ cup sugar "), _c('br'), _vm._v("¾ cup vegetable oil "), _c('br'), _vm._v("3 large eggs "), _c('br'), _vm._v("2 cups carrots, grated "), _c('br'), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v(" cup pecans "), _c('br'), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v(" cup raisins "), _c('br'), _vm._v("2 teaspoons vanilla "), _c('br'), _vm._v("1 apple, peeled and cored, chopped (1¾ cups)")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc-blocktext"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Yield: 10 muffins")])])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Preheat the oven to 400 degrees. Grease ten 3 × 1 "), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v("-inch muffin cups.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("In a medium bowl, mix the flour, baking soda, cinnamon, and salt.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("In a large bowl, combine the sugar, oil, and eggs. Mix until they are well combined. Stir in the carrots, pecans, vanilla, and apple. Fold in the flour mixture.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Spoon the mixture evenly into the prepared muffin cups. (I like to use an ice cream scoop.) The muffin cups should be filled to the top.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Bake them for 20 minutes or until a cake tester or toothpick inserted in the center of a muffin comes out clean.")])])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('div', {
    staticClass: "title-section1"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781466815902_toc01#toctitle6",
      "id": "title6"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Mincemeat Muffins")])])])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Making muffins is a wonderful way to use up leftover mincemeat from the holidays. Even people who claim they don’t like mincemeat will love these hearty muffins, especially if you don’t tell them there is mincemeat in the muffin!")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Preheat the oven to 400 degrees. Grease twelve 3 × 1 "), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v("-inch muffin cups.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("In a large bowl, stir together the flours, sugar, baking powder, and salt. In another bowl, stir together the mincemeat, eggs, water, oil, and vanilla until they are blended. Make a well in the center of the dry ingredients, add the mincemeat mixture and walnuts, and stir them until just combined.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Spoon the batter into the prepared muffin cups. Bake them for 20 to 25 minutes or until a cake tester or toothpick inserted in the center of one muffin comes out clean.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Remove the muffins to a wire rack and cool 5 minutes before removing them from the cups. Finish cooling them on the rack.")])]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "blocktext"
  }, [_c('div', {
    staticClass: "p-br-blocktext"
  }, [_c('span', [_vm._v("1 cup whole wheat flour "), _c('br'), _vm._v("1 cup all-purpose flour "), _c('br'), _vm._v("¼ cup white sugar "), _c('br'), _vm._v("1 tablespoon baking powder "), _c('br'), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v(" teaspoon salt "), _c('br'), _vm._v("1¼ cups prepared mincemeat ("), _c('span', {
    staticClass: "ref_int",
    attrs: {
      "href": "#/e9781466815902_c04#int_1",
      "id": "ref_int_1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("here")])]), _vm._v(") "), _c('br'), _vm._v("1 egg yolk "), _c('br'), _vm._v("2 whole large eggs, lightly beaten "), _c('br'), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/3")]), _vm._v(" cup water "), _c('br'), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v(" cup vegetable oil "), _c('br'), _vm._v("1 teaspoon vanilla "), _c('br'), _vm._v("1 cup walnuts, chopped")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc-blocktext"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Yield: 12 muffins")])])])]), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('div', {
    staticClass: "title-section1"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781466815902_toc01#toctitle7",
      "id": "title7"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Mocha Pecan Muffins")])])])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("A not too sweet, not too chocolaty muffin that adults and children both enjoy.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "blocktext"
  }, [_c('div', {
    staticClass: "p-br-blocktext"
  }, [_c('span', [_vm._v("2 cups all-purpose flour "), _c('br'), _vm._v("¾ cup whole wheat flour "), _c('br'), _vm._v("1 cup firmly packed dark or light brown sugar "), _c('br'), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/3")]), _vm._v(" cup Dutch-processed cocoa powder "), _c('br'), _vm._v("1 teaspoon baking soda "), _c('br'), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v(" teaspoon baking powder "), _c('br'), _vm._v("1 teaspoon salt "), _c('br'), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v(" cup vegetable oil "), _c('br'), _vm._v("¼ cup salted butter, melted "), _c('br'), _vm._v("3 large eggs "), _c('br'), _vm._v("1 cup plain yogurt, low fat or full fat "), _c('br'), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v(" teaspoon espresso powder dissolved in "), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v(" cup water (or substitute a half cup of morning coffee) "), _c('br'), _vm._v("1 teaspoon vanilla "), _c('br'), _vm._v("1 cup pecans, chopped "), _c('br'), _vm._v("1 cup mini chocolate chips")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc-blocktext"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Yield: 12 muffins")])])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Preheat the oven to 375 degrees.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Spray a 12-cup 3 × 1 "), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v("-inch muffin tin with pan spray.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("In a large bowl, combine the flours, sugar, cocoa powder, baking soda, baking powder, and salt.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("In another large bowl, combine the oil, butter, eggs, yogurt, coffee mixture, and vanilla.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Fold the wet ingredients into the dry ingredients.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Fold in the pecans and chocolate chips.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Spoon the batter evenly into the prepared muffin cups. The cups will be very full, but don’t worry, they won’t overflow. The batter will rise up nicely, and the finished product will look beautiful.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Bake them for 25 minutes or until a cake tester or toothpick inserted into the center of one muffin comes out clean.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Cool the muffins completely in the pan.")])])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('div', {
    staticClass: "title-section1"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781466815902_toc01#toctitle8",
      "id": "title8"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Orange Poppy Seed Muffins")])])])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("A very light citrus muffin with a flavor that can be changed to lemon or tangerine.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Preheat the oven to 400 degrees. Grease nine 3 × 1 "), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v("-inch muffin cups.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("In a medium-size bowl, stir together the flour, baking powder, baking soda, and salt.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("In a large bowl, cream the butter and sugar until the mixture is light and fluffy. Add the egg yolks one at a time, beating well after each addition. Beat in the orange rind and the vanilla.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Add the flour mixture and buttermilk alternately to the butter mixture, finishing with the flour mixture. Fold in the poppy seeds. Beat the egg whites to soft peaks and fold them into the flour mixture.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Spoon the batter into the prepared muffin cups, filling them to the top.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Bake them for 20 minutes or until a cake tester or toothpick inserted in the center of one muffin comes out clean.")])]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "blocktext"
  }, [_c('div', {
    staticClass: "p-br-blocktext"
  }, [_c('span', [_vm._v("1¼ cups all-purpose flour "), _c('br'), _vm._v("1¼ teaspoons baking powder "), _c('br'), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v(" teaspoon baking soda "), _c('br'), _vm._v("¼ teaspoon salt "), _c('br'), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v(" cup salted butter, softened to room temperature "), _c('br'), _vm._v("¾ cup sugar "), _c('br'), _vm._v("2 large eggs, separated "), _c('br'), _vm._v("1 tablespoon freshly grated orange rind "), _c('br'), _vm._v("1 teaspoon vanilla "), _c('br'), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v(" cup buttermilk "), _c('br'), _vm._v("2 tablespoons poppy seeds")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc-blocktext"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Yield: 9 muffins")])])])]), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('div', {
    staticClass: "title-section1"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781466815902_toc01#toctitle9",
      "id": "title9"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Banana Chocolate Chip Muffins")])])])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("When my nephew Nate Driscoll spent the summer with me, he was a big banana freak. Whenever I saw the bananas on the counter getting spots, I would turn them into something delicious, like these very rich and moist muffins.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "blocktext"
  }, [_c('div', {
    staticClass: "p-br-blocktext"
  }, [_c('span', [_vm._v("2 cups all-purpose flour "), _c('br'), _vm._v("2 teaspoons baking powder "), _c('br'), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v(" teaspoon baking soda "), _c('br'), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v(" teaspoon salt "), _c('br'), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v(" cup salted butter "), _c('br'), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v(" cup firmly packed dark or light brown sugar "), _c('br'), _vm._v("¼ cup sugar "), _c('br'), _vm._v("1 teaspoon vanilla "), _c('br'), _vm._v("2 large eggs "), _c('br'), _vm._v("1 "), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v(" cups smashed banana (the darker the skin, the better for baking) "), _c('br'), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v(" cup sour cream "), _c('br'), _vm._v("1 cup chocolate chips")])]), _vm._v(" "), _c('div', {
    staticClass: "p-br-blocktext"
  }, [_c('span', [_vm._v("2 tablespoons turbinado or raw sugar for topping (optional)")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc-blocktext"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Yield: 12 muffins")])])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Preheat the oven to 400 degrees. Grease twelve 3 × 1 "), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v("-inch muffin cups.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Mix the flour, baking powder, baking soda, and salt. Set it aside.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Cream the butter and the sugars until they are light and fluffy. Add the vanilla and eggs and mix everything well. Mix in the bananas and sour cream. Fold in the flour mixture. Fold in the chocolate chips.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Spoon the mixture into the prepared muffin cups. The cups will be very full, but don’t worry, they won’t spread over. Sprinkle them with turbinado sugar if you have it, but the muffins are fine without it.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Bake them for 20 minutes or until a cake tester or toothpick inserted in the center of one muffin comes out clean.")])])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('div', {
    staticClass: "title-section1"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781466815902_toc01#toctitle10",
      "id": "title10"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Rhubarb Crumb Muffins")])])])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("I love the sweet, tart taste of rhubarb. This muffin could be served as a small cake topped with whipped cream or ice cream. When rhubarb first appears, make these for breakfast for a spring morning treat.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Preheat the oven to 375 degrees. Grease twelve 3 × 1 "), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v("-inch muffin cups.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("TO MAKE THE CRUMB TOPPING:")]), _vm._v(" Mix the flour, sugar, and cinnamon. Mix in the butter with your fingers or a pastry blender until the mixture forms small crumbs. Set it aside. (This can be made the night before and stored in a Ziploc bag; you can even freeze it.)")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("TO MAKE THE BATTER:")]), _vm._v(" Mix the rhubarb and sugar in a small bowl and set it aside.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Mix the flour, baking powder, and salt in a small bowl and set it aside.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Beat the butter and sugar together until they are light and fluffy, about 2 minutes. Add the eggs and vanilla and beat them until they are fluffy, about 1 minute. Slowly mix in half of the flour mixture until it is incorporated, then half of the milk. Mix it and scrape down the sides of the bowl. Repeat.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Fold in the rhubarb mixture.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Divide the batter evenly into the prepared muffin cups. Distribute the crumbs evenly on top of each muffin.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Bake them for 20 minutes or until a cake tester or toothpick inserted into the center of one muffin comes out clean.")])]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "blocktext"
  }, [_c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CRUMB TOPPING")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc-blocktext"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-br-blocktext"
  }, [_c('span', [_vm._v("¾ cup all-purpose flour "), _c('br'), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/3")]), _vm._v(" cup firmly packed dark or light brown sugar "), _c('br'), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v(" teaspoon cinnamon "), _c('br'), _vm._v("5 tablespoons salted butter")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc-blocktext"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc-blocktext"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MUFFIN BATTER")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc-blocktext"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-br-blocktext"
  }, [_c('span', [_vm._v("2 cups fresh rhubarb, cut into ¼-inch pieces "), _c('br'), _vm._v("¼ cup confectioners’ sugar "), _c('br'), _vm._v("1¼ cups all-purpose flour "), _c('br'), _vm._v("1 teaspoon baking powder "), _c('br'), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v(" teaspoon salt "), _c('br'), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v(" cup salted butter softened to room temperature "), _c('br'), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v(" cup sugar "), _c('br'), _vm._v("2 large eggs "), _c('br'), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v(" teaspoon vanilla "), _c('br'), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v(" cup milk")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc-blocktext"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Yield: 12 muffins")])])])]), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('div', {
    staticClass: "title-section1"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781466815902_toc01#toctitle11",
      "id": "title11"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Double Berry Crumb Muffins")])])])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("A great all-purpose crumb muffin that tastes best with the freshest of summer berries. Make any substitutions to suit your taste.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "blocktext"
  }, [_c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CRUMB TOPPING")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc-blocktext"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-br-blocktext"
  }, [_c('span', [_vm._v("¼ cup firmly packed dark or light brown sugar "), _c('br'), _vm._v("¼ cup all-purpose flour "), _c('br'), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v(" cup pecans, chopped "), _c('br'), _vm._v("2 tablespoons salted butter, melted "), _c('br'), _vm._v("1 "), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v(" teaspoons grated orange zest from one orange")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc-blocktext"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc-blocktext"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MUFFIN BATTER")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc-blocktext"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-br-blocktext"
  }, [_c('span', [_vm._v("1 "), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v(" cups all-purpose flour "), _c('br'), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v(" cup sugar "), _c('br'), _vm._v("2 teaspoons baking powder "), _c('br'), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v(" teaspoon cinnamon "), _c('br'), _vm._v("¼ teaspoon salt "), _c('br'), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v(" cup milk "), _c('br'), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v(" cup salted butter, melted "), _c('br'), _vm._v("1 large egg "), _c('br'), _vm._v("1 cup blackberries, cut them in half if they are large "), _c('br'), _vm._v("1 cup raspberries")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc-blocktext"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Yield: 12 muffins")])])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Preheat the oven to 400 degrees. Grease twelve 3 × 1 "), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v("-inch muffin cups.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("TO MAKE THE TOPPING:")]), _vm._v(" In a small bowl, combine the sugar, flour, pecans, butter, and orange zest. Mix it together until it is crumbly. Set it aside.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("TO MAKE THE BATTER:")]), _vm._v(" In a large bowl, combine the flour, sugar, baking powder, cinnamon, and salt. In a separate small bowl, combine the milk, butter, and egg.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Add the milk mixture to the dry ingredients and fold them in. Fold in the berries and spoon the batter equally into the prepared muffin cups.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Spoon the crumb mixture evenly on top of each muffin.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Bake them for 20 minutes or until a cake tester or toothpick inserted in the center of one muffin comes out clean and the top is golden brown.")])])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('div', {
    staticClass: "title-section1"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781466815902_toc01#toctitle12",
      "id": "title12"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Oatmeal Scones")])])])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("When I was living in England in 1979, I used to love what they called wholemeal scones. I am not exactly sure how they were made; but this is as close as I can remember.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Preheat the oven to 375 degrees. Grease two cookie sheets or line them with Silpat.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("In a large bowl, stir together the flours, oatmeal, baking powder, sugar, and salt. Using two knives or a pastry blender, cut in the butter and blend it until the mixture is crumbly and the size of peas. Add the chopped dates. Slowly pour in the half-and-half while mixing continuously. Beat it for 1 minute. The dough will be sticky. Turn it out onto a floured board and knead it gently.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Roll out the dough on a lightly floured board to a thickness of ¾ inch. (I actually prefer to just pat it down gently to the thickness I want because this dough is very soft.) Cut the dough with a 3-inch round cutter lightly dipped in flour. Place the scones on the prepared cookie sheets about 2 inches apart.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Make an egg wash by beating the egg and sugar together. Brush it lightly on the top of each scone.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Bake the scones for 20 minutes or until they are slightly golden in color.")])]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "blocktext"
  }, [_c('div', {
    staticClass: "p-br-blocktext"
  }, [_c('span', [_vm._v("1 cup all-purpose flour "), _c('br'), _vm._v("1 cup whole wheat pastry flour "), _c('br'), _vm._v("2 cups old-fashioned rolled oatmeal "), _c('br'), _vm._v("2 tablespoons baking powder "), _c('br'), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v(" cup firmly packed dark or light brown sugar "), _c('br'), _vm._v("¼ teaspoon salt "), _c('br'), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v(" cup salted butter, cut into pieces "), _c('br'), _vm._v("1 cup dates, pitted and chopped "), _c('br'), _vm._v("1¾ cups half-and-half")])]), _vm._v(" "), _c('div', {
    staticClass: "p-br-blocktext"
  }, [_c('span', [_vm._v("1 large egg "), _c('br'), _vm._v("1 teaspoon sugar")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc-blocktext"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Yield: 14 large scones")])])])]), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('div', {
    staticClass: "title-section1"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781466815902_toc01#toctitle13",
      "id": "title13"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Scott’s Drop Scones")])])])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("My friend Scott Goldsmith loves weekends in the Hamptons and shopping at the bake shop, but he has his own favorite scone recipe. What makes this one so easy is that you don’t have to roll the dough out. These scones are best served warm.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "blocktext"
  }, [_c('div', {
    staticClass: "p-br-blocktext"
  }, [_c('span', [_vm._v("2 cups all-purpose flour "), _c('br'), _vm._v("¼ cup sugar "), _c('br'), _vm._v("1 tablespoon baking powder "), _c('br'), _vm._v("¼ teaspoon salt "), _c('br'), _vm._v("¾ cup dried currants "), _c('br'), _vm._v("1¼ cups heavy cream "), _c('br'), _vm._v("2 tablespoons salted butter, melted")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc-blocktext"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Yield: 12 scones")])])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Preheat the oven to 425 degrees.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("In a large bowl, combine the flour, sugar, baking powder, and salt. Mix the ingredients well and add the currants, breaking them apart with your hands if any are stuck together.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Add the heavy cream and mix with a fork until they are just combined. The dough will be sticky. Dump it onto a lightly floured board and knead it 6 to 8 times with the heels of your hands. Tear pieces of the dough off and drop them onto an ungreased cookie sheet. Pat down the dough to about 1-inch thick.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Brush the tops with the melted butter.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Bake the scones for 15 minutes or until they just begin to brown lightly.")])])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('div', {
    staticClass: "title-section1"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781466815902_toc01#toctitle14",
      "id": "title14"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ginger Scones")])])])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Ginger is one of my favorite spices, especially around Christmastime. These scones are very light and simple. Serve them with orange marmalade and butter for a special presentation.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Preheat the oven to 375 degrees. Lightly grease one cookie sheet or line them with Silpat.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("In a food processor, combine the flour, sugar, baking powder, cinnamon, ground ginger, cloves, and salt.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Add the butter and process until the mixture resembles coarse meal. Add the crystallized ginger and pulse once or twice to combine the ingredients.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Mix the half-and-half, egg, and vanilla in a separate bowl.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Add it to the flour mixture and process it until the ingredients are just combined.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Turn the dough out onto a lightly floured surface. Roll it out to a 1-inch thickness and cut it to the desired size. (I like scones small, so I use a 2-inch round cutter.)")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Place the scones 2 inches apart on the prepared cookie sheet. Brush them with an egg wash made by beating one egg with 1 tablespoon of water. Sprinkle them with turbinado sugar.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Bake them for 20 minutes or until they are golden brown around the edges. Serve them warm.")])]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "blocktext"
  }, [_c('div', {
    staticClass: "p-br-blocktext"
  }, [_c('span', [_vm._v("2 cups all-purpose flour "), _c('br'), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v(" cup firmly packed dark or light brown sugar "), _c('br'), _vm._v("1 tablespoon baking powder "), _c('br'), _vm._v("1 teaspoon cinnamon "), _c('br'), _vm._v("¾ teaspoon ground ginger "), _c('br'), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/8")]), _vm._v(" teaspoon cloves "), _c('br'), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/8")]), _vm._v(" teaspoon salt "), _c('br'), _vm._v("6 tablespoons salted butter, chilled and cut into small pieces "), _c('br'), _vm._v("¼ cup chopped crystallized ginger "), _c('br'), _vm._v("¼ cup half-and-half "), _c('br'), _vm._v("1 large egg "), _c('br'), _vm._v("1 teaspoon vanilla")])]), _vm._v(" "), _c('div', {
    staticClass: "p-br-blocktext"
  }, [_c('span', [_vm._v("1 large egg "), _c('br'), _vm._v("2 tablespoons turbinado sugar (for topping)")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc-blocktext"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Yield: 13 two-inch scones")])])])]), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('div', {
    staticClass: "title-section1"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781466815902_toc01#toctitle15",
      "id": "title15"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Apricot Ginger Scones")])])])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("We sell tons of scones at Tate’s Bake Shop. I learned to make these when I studied in England. Traditionally, they are made with raisins, but this one is my favorite combination.")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('br'), _c('div', {
    staticClass: "blocktext"
  }, [_c('div', {
    staticClass: "p-br-blocktext"
  }, [_c('span', [_vm._v("4 cups all-purpose flour "), _c('br'), _vm._v("2 tablespoons baking powder "), _c('br'), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v(" teaspoon salt "), _c('br'), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v(" cup sugar "), _c('br'), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v(" cup cold salted butter, cut into 8 pieces "), _c('br'), _vm._v("1 cup dried apricots, chopped (I always use California apricots, and for this recipe I prefer them glacé.) "), _c('br'), _c('span', {
    staticClass: "fraction"
  }, [_vm._v("1/2")]), _vm._v(" cup crystallized ginger, chopped")])]), _vm._v(" "), _c('div', {
    staticClass: "p-br-blocktext"
  }, [_c('span', [_vm._v("1¾ cups half-and-half "), _c('br'), _vm._v("1 large egg "), _c('br'), _vm._v("1 teaspoon sugar")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc-blocktext"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blocktext"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Yield: 14 large scones")])])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Preheat the oven to 375 degrees. Grease two cookie sheets or line them with Silpat.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("In a large bowl, stir together the flour, baking powder, salt, and sugar. Using a pastry blender or two knives, cut in the cold butter and blend the ingredients until the mixture is crumbly and about the size of peas. Add the apricots and ginger and toss. Slowly pour in the half-and-half while mixing continuously. Mix the ingredients vigorously with a wooden spoon for 1 minute, or use a mixer with a paddle attachment.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Roll the dough out on a lightly floured board to a thickness of ¾ inch. Cut it with a 3-inch round cutter lightly dipped in flour. Place the scones on the prepared cookie sheets about 2 inches apart.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Make an egg wash by beating the egg and sugar together. Brush the egg wash lightly on top of each scone.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Bake the scones for 25 to 30 minutes or until they are light golden in color.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42fa31da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781466815902_c01.vue
// module id = 75
// module chunks = 0